import { useState } from 'react'

import classNames from 'classnames'

import {
  CommonBookmarkIcon,
  CommonBookmarkActiveIcon,
  CommonBookmark2Icon,
  CommonBookmarkActive2Icon,
  PlaceBookmarkIcon,
  PlaceBookmarkActiveIcon,
} from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import { gql } from '@web/gql'
import { BookmarkButtonFragment, BookmarkButton_AddressFragment } from '@web/gql/graphql'
import { useGoTo } from '@web/hooks/useGoTo'
import { useMapWidget } from '@web/hooks/useMapWidget'
import useMe from '@web/hooks/useMe'

import { ButtonBookmarkType } from './BookmarkButton.constant'
import styles from './BookmarkButton.module.scss'

const getClassNames = (type: ButtonBookmarkType) => ({
  [styles.type_review_card]: type === ButtonBookmarkType.REVIEW_TAB || type === ButtonBookmarkType.REVIEW_TAB_OTHERS,
  [styles.type_visit]: type === ButtonBookmarkType.VISIT,
})

const getIcon = (type?: ButtonBookmarkType) => {
  switch (type) {
    case ButtonBookmarkType.REVIEW_TAB:
      return CommonBookmarkActive2Icon
    case ButtonBookmarkType.REVIEW_END:
      return PlaceBookmarkActiveIcon
    default:
      return CommonBookmarkActiveIcon
  }
}

const getActiveIcon = (type?: ButtonBookmarkType) => {
  switch (type) {
    case ButtonBookmarkType.REVIEW_TAB:
      return CommonBookmark2Icon
    case ButtonBookmarkType.REVIEW_END:
      return PlaceBookmarkIcon
    default:
      return CommonBookmarkIcon
  }
}
type Props = {
  place: BookmarkButtonFragment | BookmarkButton_AddressFragment
  showLabel?: boolean
  nClickCodes?: {
    save: string
    unsave: string
  }
  type?: ButtonBookmarkType
  callback?: (isBookmarked: boolean) => void
}

const BookmarkButton = ({ place, type, showLabel = false, nClickCodes, callback }: Props) => {
  const { isBookmarked: originalBookmarked } = place
  const [isBookmarked, setIsBookmarked] = useState(originalBookmarked)

  const { me } = useMe()

  const { goToLogin } = useGoTo()

  const handleBookmarkChange = (isBookmarked: boolean) => {
    setIsBookmarked(isBookmarked)
    callback?.(isBookmarked)
  }
  const { openBookmark } = useMapWidget()

  const onClickBookmarkButton = () => {
    if (!me?.id) {
      return goToLogin({ showAlert: true })
    }

    return openBookmark({ place, handleBookmarkChange })
  }

  const BookmarkIcon = isBookmarked ? getIcon(type) : getActiveIcon(type)
  return (
    <>
      <Clickable
        aria-pressed={isBookmarked}
        className={classNames(styles.btn, !!type && getClassNames(type), { [styles.type_has_label]: showLabel })}
        nClickCode={isBookmarked ? nClickCodes?.unsave : nClickCodes?.save}
        onClick={onClickBookmarkButton}
        stopPropagation
      >
        <BookmarkIcon className={styles.icon} aria-hidden="true" />
        <span className={classNames(styles.label, { place_blind: !showLabel })}>저장</span>
      </Clickable>
    </>
  )
}

BookmarkButton.fragments = {
  place: gql(`
    fragment BookmarkButton on Place {
      id
      name
      roadAddress
      jibunAddress
      coordinate {
        longitude
        latitude
      }
      isBookmarked
    }
  `),
  address: gql(`
    fragment BookmarkButton_Address on Address {
      name
      roadAddress
      jibunAddress
      coordinate {
        longitude
        latitude
      }
      isBookmarked
      rcode
      isDetailAddress
      isNewAddress
    }
  `),
}

export default BookmarkButton
